import { ReloadOutlined } from '@ant-design/icons';
import { clearPageLoads } from 'library/helpers/reloadLoopGuard';
import StatusScreen from 'publicContainer/StatusScreen';
import React from 'react';
import { Button } from 'zui/Antd';

const continueLoading = () => {
	clearPageLoads();
	window.location.reload();
};

// Rendered INSTEAD of the app when this tab has reloaded too often (library/helpers/reloadLoopGuard).
// Nothing has booted, so no API call is made until Continue is pressed.
const ReloadLoop = () => (
	<StatusScreen
		tone='warning'
		icon={<ReloadOutlined />}
		title='This tab keeps reloading'
		description='The dashboard has loaded many times in the last minute, so it has paused. If you did not reload it yourself, close this tab and tell the Zezamii team.'
		actions={
			<Button type='primary' block onClick={continueLoading}>
				Continue
			</Button>
		}
	/>
);

export default ReloadLoop;
